import { Component, OnInit, Input, Output } from '@angular/core';
import { EventEmitter } from 'events';

@Component({
  selector: 'app-consulta-protesto',
  templateUrl: './consulta-protesto.component.html',
  styleUrls: ['./consulta-protesto.component.scss']
})
export class ConsultaProtestoComponent implements OnInit {

  @Input() consulta: any;
  @Input() titulo="";
  @Input() idConsulta="";
  @Input() tipoConsulta="";
  @Input() codigoControle="";
  @Output() update = new EventEmitter();

  statusMsg = null;
  status = "info";
  msgNull = 'NÃO INFORMADO';

  constructor() { }

  ngOnInit() {
    this.getStatus();
  }

  getStatus() {
   

    if(!this.consulta.registros || this.consulta.registros.length == 0) {
      this.codigoControle = 'SEMREGISTRO_OK';
    } else {
      this.codigoControle == 'OK' ? this.status = 'warning' : 'success';
    }

    this.codigoControle == 'SEMREGISTRO_OK' ? this.status = 'success' : 'warning';
  }

}
